import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import theaterButtons from 'website/containers/user/theaterButtons';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import thirdNav from 'website/module/ui/third-nav';
import loadAccesLibre from 'website/third_party/acces-libre';

applicationBootstrap().then(() => {
  theaterButtons();
  facebookWidgets();
  roller();
  thirdNav();
  loadAccesLibre();
});
